<section *ngIf="show">
    <div data-cy="callback-publicfacing-api__page" class="w-100 text-align-center position-set">
        <img src="../../apple-touch-icon-precomposed.png">
        <h1 class="code-set">Copy the following Code</h1>
        <div class="d-flex">
            <h1 class="code-set truncate">{{code}}</h1>
            <button data-cy="callback-publicfacing-api__button-transparent-btn" (click)="copyMessage(code)" matTooltip="Copy Clipboard" class="button-transparent"><mat-icon>content_copy</mat-icon></button>
        </div>
    </div>
</section>